

















































import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import { FormRadioOption } from '~/types/ui';

export default defineComponent({
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /** 入力値 */
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    options: {
      type: Array as PropType<FormRadioOption[]>,
      required: true,
    },
    /** VeeValidateのバリデーションルール */
    rules: {
      type: [String, Object],
      default: null,
    },
    /** VeeValidateのバリデーションID */
    vid: {
      type: String,
      default: null,
    },
    /** VeeValidateのフィールドラベル */
    fieldName: {
      type: String,
      default: null,
    },
    tightMargin: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    /** 注記に改行があるか */
    hasNewLine: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    /** ラジオボタン再押下で選択解除できるかどうか */
    canDeselect: {
      type: Boolean,
      default: false,
    },
    /** 選択されているラベルを太字にするかどうか */
    isCheckedLabelBold: {
      type: Boolean,
      default: false,
    },
    radioClass: {
      type: String,
      default: 'form-radio',
    },
    inputIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    noteTextClass: {
      type: String,
      default: 'text-sm text-Black80',
    },
  },
  setup(props, { emit }) {
    const localValue = computed({
      get() {
        return props.value;
      },
      set(value: string | number | boolean) {
        emit('input', value);
      },
    });

    const onClickRadio = (clickedValue: string | number | boolean) => {
      // 選択解除可能かつ同じ値を再選択した場合は選択解除
      if (props.canDeselect && clickedValue === localValue.value) {
        localValue.value = '';
      }
    };

    return {
      localValue,
      onClickRadio,
    };
  },
});
